module.exports = __webpack_public_path__ + "img/st-icon.c5dfbe2.png";